export default {
    parameters: {
        landing_id: "TrSMP",
    },
    new_social_proof: true,
    downtimeUrl: "https://cl.kodland.tech",
    showSocialProof: true,
    startPage: {
      title: "5 soruyu yanıtlayın ve çocuğunuz için ÜCRETSİZ ders alın",
      subtitle:
        "Çocuklar dijital yaratıcılıkta yeteneklerini deneyecekler: çizgi film, animasyon, illüstrasyon, modelleme, 3D, tasarım",
      button: "Ders alın 🚀",
      imageMobile: {
        url: "/welcome/quiz_turkey_supermega_social_proof_mobile.png",
        style: {
          width: "100%",
        },
      },
      image: {
        url:  "/welcome/quiz_turkey_supermega_social_proof_pk.png",
        style: {
            height: "100%",
            "max-height": "100vh",
        },
      },
    },
      stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
      1: {
        question: "Çocuğunuz genellikle boş zamanlarını nasıl geçirir?",
        image: {
            image_main: "/welcome/quiz_turkey_supermega_Social_proof_q1.png",
            imageMobile: "/welcome/quiz_turkey_supermega_Social_proof_q1.png",
            isMainImage: true,
            isVideo: false,
          },
        answers: [
          {
            answer:"Cep telefonu ve bilgisayarda oyun oynar",
            img: "/welcome/turkey_quiz_supermega_social_proof_q1a1.png",
            isImage: true,
          },
          {
            answer: "Sanatsal faaliyetlerde bulunur: çizim, müzik, oyunculuk",
            img: "/welcome/turkey_quiz_supermega_social_proof_q1a2.png",
            isImage: true,
          },
          {
            answer: "Spor yapar",
            img: "/welcome/turkey_quiz_supermega_social_proof_q1a3.png",
            isImage: true,
          },
          {
            answer:"Ailesiyle vakit geçirir",
            img: "/welcome/turkey_quiz_supermega_social_proof_q1a4.png",
            isImage: true,
          },
          {
            answer:"Çizgi film izler",
            img: "/welcome/turkey_quiz_supermega_social_proof_q1a5.png",
            isImage: true,
          },
          {
            answer:"Arkadaşlarıyla sosyalleşir",
            img: "/welcome/turkey_quiz_supermega_social_proof_q1a6.png",
            isImage: true,
          },
        ],
      },
      2: {
        question: "Çocuğunuzun okulda en sevdiği ders hangisidir?",
        image: {
            image_main: "/welcome/quiz_turkey_supermega_Social_proof_q2.png",
            imageMobile: "/welcome/quiz_turkey_supermega_Social_proof_q2.png",
            isMainImage: true,
            isVideo: false,
          },
        answers: [
          {
            answer: "Fen bilimleri",
            img: "/welcome/turkey_quiz_supermega_social_proof_q2a1.png",
            isImage: true,
          },
          {
            answer: "Sanat ve tasarım",
            img: "/welcome/turkey_quiz_supermega_social_proof_q1a2.png",
            isImage: true,          
          },
          {
            answer: "Bilgisayar bilimi",
            img: "/welcome/turkey_quiz_supermega_social_proof_q2a3.png",
            isImage: true,
          },
          {
            answer: "Tarih, Edebiyat",
            img: "/welcome/turkey_quiz_supermega_social_proof_q2a4.png",
            isImage: true,
          },
          {
            answer: "Matematik",
            img: "/welcome/turkey_quiz_supermega_social_proof_q2a5.png",
            isImage: true,
          },
          {
            answer: "Yabancı diller",
            img: "/welcome/turkey_quiz_supermega_social_proof_q2a6.png",
            isImage: true,
          },
          {
            answer: "Tüm dersler",
            img: "/welcome/turkey_quiz_supermega_social_proof_q2a7.png",
            isImage: true,
          },
          {
            answer: "Emin değilim",
            img: "/welcome/turkey_quiz_supermega_social_proof_q2a8.png",
            isImage: true,
          },
        ],
      },
      3: {
        title: "Deneme dersi için hangi saatte uygunsunuz?",
        image: {
            image_main: "/welcome/quiz_turkey_supermega_Social_proof_q3.png",
            imageMobile: "/welcome/quiz_turkey_supermega_Social_proof_q3.png",
            isMainImage: true,
            isVideo: false,
          },
        type: "timeslot",
        subtitle:
          "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
        button: "Rezervasyon için tıklayın 🎁",
      },
      4: {
        question: "Çocuğunuzun herhangi bir bilgisayar becerisi var mı?",
        image: {
            image_main: "/welcome/quiz_turkey_supermega_Social_proof_q4.png",
            imageMobile: "/welcome/quiz_turkey_supermega_Social_proof_q4.png",
            isMainImage: true,
            isVideo: false,
          },
        answers: [
          {
            answer:"Evet, Microsoft Word/PowerPoint",
            img: "/welcome/turkey_quiz_supermega_social_proof_q3a1.png",
            isImage: true,
          },
          {
            answer:"Evet, temel kodlama",
            img: "/welcome/turkey_quiz_supermega_social_proof_q3a2.png",
            isImage: true,
          },
          {
            answer:"Evet, oyun oynamayı sever (Roblox, Minecraft)",
            img: "/welcome/turkey_quiz_supermega_social_proof_q3a3.png",
            isImage: true,
          },
          {
            answer:"Hayır",
            img: "/welcome/turkey_quiz_supermega_social_proof_q2a8.png",
            isImage: true,
          },
        ],
      },
      5: {
        question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
        answers: [
          {
          answer: "💻 Evet",
          distribution_tag_question: [18],
          img: "/welcome/turkey_quiz_supermega_social_proof_q4a1.png",
          isImage: true,          
          },
          {
            answer: "😐 Hayır",
            stopAnswer: true,
            img: "/welcome/turkey_quiz_supermega_social_proof_q4a2.png",
            isImage: true,            
          },
        ],
      },
      6: {
        image: {
            image_main: "/welcome/quiz_turkey_supermega_Social_proof_q6.png",
            imageMobile: "/welcome/quiz_turkey_supermega_Social_proof_q6.png",
            isMainImage: true,
            isVideo: false,
          },
        title: "Çocuğunuz kaç yaşında?",
        type: "age",
        subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz",
        button: "İleri 🚀",
      },
      7: {
        image: {
            image_main: "/welcome/quiz_turkey_supermega_Social_proof_q7.png",
            imageMobile: "/welcome/quiz_turkey_supermega_Social_proof_q7.png",
            isMainImage: true,
            isVideo: false,
          },
        title: "Çocuğunuzun adı nedir?",
        type: "child_name",
        subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
        button: "İleri 🚀",
      },
      8: {
        title: "E-postanızı girin",
        type: "mail",
        subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
        button: "İleri 🚀",
      },
      9: {
        title: "Telefon numaranızı girin",
        type: "phone",
        subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
        button: "Neredeyse bitti 🔥",
      },
      10: {
        title: "İsminizi girin",
        type: "parent_name",
        subtitle: "Bizim adımız Kodland, sizinki ne?👋",
        button: "Son adım! 🎉",
      },
    },
  };